import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listBgMasters,
  updateBgMaster,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * BG マスタ更新 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * optimistic locking: expected_updated_at を request に含める。
 */
export function useUpdateBgMaster(): InvalidatingMutationResultFor<
  typeof updateBgMaster
> {
  return useInvalidatingMutation(updateBgMaster, [
    createConnectQueryKey({ schema: listBgMasters, cardinality: 'finite' }),
  ])
}
